import { render } from "./ChekboxesOrder.vue?vue&type=template&id=b6166290"
import script from "./ChekboxesOrder.vue?vue&type=script&lang=js"
export * from "./ChekboxesOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__